import { type Task, taskScheduleIntakeContextOptions } from '@cartwheel/api/v1'
import { useQuery } from '@tanstack/react-query'
import {
  AvailabilityNote,
  CanceledNotice,
  ScheduleAppointmentsSection,
  SectionDivider,
  TaskDescription,
} from './shared/task-workspace-primitives'

export function SchedulePsychIntakeWorkspace({
  task,
  canWork = true,
}: {
  task: Task
  canWork?: boolean
  onClose: () => void
}) {
  const { data } = useQuery(taskScheduleIntakeContextOptions({ path: { task_id: task.id } }))

  if (task.status === 'canceled') {
    return (
      <div className="space-y-8">
        <TaskDescription task={task} />
        <CanceledNotice />
      </div>
    )
  }

  if (task.status === 'completed') {
    return (
      <div className="space-y-8">
        <TaskDescription task={task} />
        <section className="space-y-3">
          <h3 className="text-base font-semibold leading-[1.5] text-charcoal">Completed</h3>
          <div className="rounded-lg border border-sand bg-white p-4 shadow-sm">
            <p className="text-sm leading-[1.5] text-charcoal-50">
              A psychiatry intake appointment has been scheduled for this client.
            </p>
          </div>
        </section>
      </div>
    )
  }

  return (
    <div className="space-y-8">
      <TaskDescription task={task} />

      {data?.availability_note && <AvailabilityNote note={data.availability_note} />}

      {canWork && (
        <>
          <SectionDivider />
          <section className="space-y-4">
            <div>
              <h3 className="text-base font-semibold leading-[1.5] text-charcoal">Resolution</h3>
              <p className="text-sm leading-[1.5] text-charcoal-50">Schedule appointments</p>
            </div>
            <ScheduleAppointmentsSection
              task={task}
              matchingCliniciansCount={data?.matching_clinicians_count}
              caseAssignmentUrl={data?.case_assignment_url}
            />
          </section>
        </>
      )}
    </div>
  )
}
